import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"
import {useUniWebTemplate} from "~/composables/useUniWebTemplate"
import type ArticleFilters from "~/libs/interfaces/ArticleFilters"

export const useStaticMenuConfig = (config: Record<TemplateList, StaticMenuItem[]>) => {
  const getConfig = ():StaticMenuItem[] => {
    return useUniWebTemplate().getTemplateListItem() !== null ? config[useUniWebTemplate().getTemplateListItem() as TemplateList] : []
  }

  const getMenuItemByUrl = (url: string, sections?: StaticMenuItem[]):StaticMenuItem | undefined => {
    if (!url) {
      return
    }

    const levelSections = sections || getConfig()
    if (url.charAt(0) === '/') {
      url = url.slice(1, url.length)
    }

    for(let item of levelSections) {
      if (item.url === url) {
        return item
      }
      if (item.items) {
        const found = getMenuItemByUrl(url, item.items)
        if (found) {
          return found
        }
      }
    }
  }

  const mergeFilters = (filters1: ArticleFilters, filters2: ArticleFilters, replaceExisting: boolean = false): ArticleFilters => {
    let mergedFilters = {
      ...filters1
    }

    if (replaceExisting && filters2.ids) {
      mergedFilters.magazineIds = filters2.ids
    } else if (filters2.ids) {
      mergedFilters.ids = mergeArrays(filters1.ids, filters2.ids)
    }

    if (replaceExisting && filters2.magazineIds) {
      mergedFilters.magazineIds = filters2.magazineIds
    } else if (filters2.magazineIds) {
      mergedFilters.magazineIds = mergeArrays(filters1.magazineIds, filters2.magazineIds)
    }

    if (replaceExisting && filters2.categoryIds) {
      mergedFilters.categoryIds = filters2.categoryIds
    } else if (filters2.categoryIds) {
      mergedFilters.categoryIds = mergeArrays(filters1.categoryIds, filters2.categoryIds)
    }

    if (replaceExisting && filters2.authorIds) {
      mergedFilters.authorIds = filters2.authorIds
    } else if (filters2.authorIds) {
      mergedFilters.authorIds = mergeArrays(filters1.authorIds, filters2.authorIds)
    }

    if (replaceExisting && filters2.paths) {
      mergedFilters.paths = filters2.paths
    } else if (filters2.paths) {
      mergedFilters.paths = mergeArrays(filters1.paths, filters2.paths)
    }

    if (filters2.fulltext !== undefined) {
      mergedFilters.fulltext = filters2.fulltext
    }

    return mergedFilters
  }

  const mergeArrays = (arr1?: any[], arr2?: any[]): any[] | undefined => {
    if (!arr1 && !arr2) {
      return
    }
    if (arr1 && !arr2) {
      return arr1
    }
    if (!arr1 && arr2) {
      return arr2
    }
    if (arr1 && arr2) {
      return arr2.reduce(
        (acc, item) => {
          return acc.includes(item) ? acc : [...acc, item]
        },
        [...arr1]
      )
    }
  }

  const getMenuItemsFilters = (sections?: StaticMenuItem[]): ArticleFilters => {
    let filters = {}
    if (sections) {
      for (let item of sections) {
        if (item.filters) {
          filters = mergeFilters(filters, item.filters)
        }
        if (item.items && item.items.length > 0) {
          filters = mergeFilters(filters, getMenuItemsFilters(item.items))
        }
      }
    }
    return filters
  }

  const getDefaultFilters = (): ArticleFilters => {
    return mergeFilters({
        magazineIds: useMagazineIds()
      },
      getMenuItemsFilters(
        getConfig()
      ),
      true
    )
  }

  return {
    getConfig,
    getMenuItemByUrl,
    getMenuItemsFilters,
    getDefaultFilters,
    mergeFilters,
    mergeArrays
  }
}


